import React from 'react';

import { DelayedSearch, DelayedSearchProps } from 'app/components/delayed-search';
import { GeneralConstants } from 'app/constants/general-constants';
import { LocationGroup } from 'app/model/cris/location-group';
import { KnpPaginationData } from 'app/model/knp-pagination-data';
import { locationGroupService } from 'app/services/location-group.service';
import { EntityOnChange } from 'app/type';
import { InputValueUtils } from 'app/utils/input-value-utils';

type OmitFields = 'getOptionLabel' | 'mapDataToOptions' | 'name' | 'onChange' | 'onSearch' | 'value';

interface LocationGroupPickerProps<T> extends Omit<DelayedSearchProps<LocationGroup, undefined>, OmitFields> {
    name: keyof T;
    value: T;
    onChange?: EntityOnChange<T, LocationGroup | undefined>;
}

export const LocationGroupPicker = <T extends object>(props: LocationGroupPickerProps<T>): React.ReactElement => {
    const { value, name, onChange, ...rest } = props;

    // todo see if we can improve prop signature to auto detect this and avoid unknown conversion
    const data = value[name] as unknown as LocationGroup | undefined;

    return (
        <DelayedSearch
            variant='standard'
            label='Pick Location Group'
            {...rest}
            name={name as string}
            value={InputValueUtils.optionalObject(data)}
            onSearch={(input) =>
                locationGroupService.list({
                    pageSize: GeneralConstants.PAGE_SIZE_LARGE,
                    queryFilters: {
                        search: input,
                    },
                })
            }
            mapDataToOptions={(response: KnpPaginationData<LocationGroup>) => response.data}
            getOptionLabel={(option) => Object.values(option || ['(NONE)']).join('; ')}
            isOptionEqualToValue={(option, curValue) => option.id === curValue.id}
            onChange={(evt, curValue) => {
                onChange?.(evt, name, InputValueUtils.optionalOutput(curValue));
            }}
        />
    );
};
